import { render, staticRenderFns } from "./TravisMD.vue?vue&type=template&id=5070debc&scoped=true"
import script from "./TravisMD.vue?vue&type=script&lang=js"
export * from "./TravisMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5070debc",
  null
  
)

export default component.exports